import { STATUS } from '@/constants'

// true status as defined in api
export enum Status {
  'Unknown' = 'unknown',
  'Draft' = 'draft',
  'New' = 'new',
  'Pending' = 'pending',
  'Queued' = 'queued',
  'Starting' = 'starting',
  'Started' = 'started',
  'Active' = 'active',
  'Changed' = 'changed',
  'Updated' = 'updated',
  'Resolved' = 'resolved',
  'Transiting' = 'transiting',
  'Ready' = 'ready',
  'Final' = 'final',
  'Cancelled' = 'cancelled',
  'Failed' = 'failed',
  'Stopped' = 'stopped',
  'Paused' = 'paused',
  'Deleted' = 'deleted',
  'Unsourced' = 'unsourced',
  'Sourcing' = 'sourcing',
  'Sourced' = 'sourced',
  'Archived' = 'archived',
  'Replaced' = 'replaced'
}

// status paired to display value
export const DisplayStatus = {
  [Status.Unknown]: 'Unknown',
  [Status.New]: 'New',
  [Status.Pending]: 'Pending',
  [Status.Queued]: 'Ready To Pick',
  [Status.Starting]: 'Picking',
  [Status.Started]: 'Picked',
  [Status.Active]: 'Packing',

  [Status.Changed]: 'Changed',
  [Status.Updated]: 'Updated',

  [Status.Resolved]: 'Packed',
  [Status.Transiting]: 'In Transit',
  [Status.Ready]: 'Ready for Pickup',
  [Status.Final]: 'Delivered',

  [Status.Cancelled]: 'Cancelled',
  [Status.Failed]: 'Issue',
  [Status.Stopped]: 'Blocked',
  [Status.Paused]: 'On Hold',
  [Status.Deleted]: 'Deleted',
  [Status.Unsourced]: 'Unsourced',
  [Status.Sourcing]: 'Sourcing',
  [Status.Sourced]: 'Sourced',
  [Status.Archived]: 'Archived'
}
